import { useAppSelector } from "@/store/store";

/**
 * Whether the signed-in account may use the internal super-admin console.
 *
 * FOR RENDERING ONLY. It reads a field off the profile response, so it answers
 * "should this UI exist for them", never "are they allowed to do this" — the
 * authorisation lives in `requireSuperAdmin` on every /api/admin route, which
 * answers 404 to everybody else. Forcing this true in a browser gets you a console
 * where every single request fails.
 *
 * Returns `null` while the session is still being established, which is a third
 * state and not a synonym for false: treating "don't know yet" as "not an admin" is
 * what makes a guard redirect an admin away from their own console during the first
 * paint of a page load.
 */
export function useIsSuperAdmin(): boolean | null {
  const status = useAppSelector((state) => state.auth.status);
  const isSuperAdmin = useAppSelector((state) => state.auth.currentUser?.isSuperAdmin);

  if (status === "unknown") return null;
  return isSuperAdmin === true;
}

export default useIsSuperAdmin;
